import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../../schema.dexie";
import { listarExperiencias } from "../queries";
import { STATUS_EXPERIENCIA_LABEL, type StatusExperiencia } from "../types";
import { ExperienciaFoto } from "../ui/ExperienciaFoto";
import { StatusExperienciaBadge } from "../ui/StatusExperienciaBadge";
import { IndicadorEngajamento } from "../ui/IndicadorEngajamento";

type Filtro = "todas" | StatusExperiencia;

const FILTROS: { v: Filtro; r: string }[] = [
  { v: "todas", r: "todas" },
  { v: "favorita", r: "favoritas" },
  { v: "em_exploracao", r: "em exploração" },
  { v: "sensivel", r: "sensíveis" },
  { v: "nao_usada", r: "não usadas" },
];

const FILTROS_VALIDOS = new Set<Filtro>(FILTROS.map((f) => f.v));

export function BibliotecaMusica() {
  const nav = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const param = searchParams.get("status") as Filtro | null;
  const filtro: Filtro = param && FILTROS_VALIDOS.has(param) ? param : "todas";
  const setFiltro = (f: Filtro) =>
    setSearchParams(f === "todas" ? {} : { status: f }, { replace: true });

  const experiencias = useLiveQuery(() => listarExperiencias()) ?? [];
  const momentos = useLiveQuery(() => db.momento.toArray()) ?? [];

  const lista =
    filtro === "todas" ? experiencias : experiencias.filter((e) => e.status === filtro);

  return (
    <main className="tela">
      <button className="btn btn-fantasma" onClick={() => nav(-1)}>
        ← voltar
      </button>
      <div className="row-entre">
        <h1 className="tela-titulo">biblioteca</h1>
        <Link to="/compasso/biblioteca/nova" className="btn btn-primario">
          ➕ nova
        </Link>
      </div>

      <div className="chips" style={{ marginBottom: "var(--s4)" }}>
        {FILTROS.map((f) => (
          <button
            key={f.v}
            className="chip"
            style={
              filtro === f.v
                ? {
                    background: "var(--accent-suave-bg)",
                    color: "var(--accent-forte)",
                    borderColor: "var(--accent-suave-borda)",
                  }
                : undefined
            }
            onClick={() => setFiltro(f.v)}
          >
            {f.r}
          </button>
        ))}
      </div>

      {lista.length === 0 ? (
        <div className="vazio">
          <span className="emoji" aria-hidden>
            🎵
          </span>
          {experiencias.length === 0
            ? "nenhuma experiência ainda. comece cadastrando uma."
            : "nada neste filtro."}
        </div>
      ) : (
        <div className="lista-cards">
        {lista.map((e) => (
          <button
            className="card linha-alimento"
            key={e.id}
            onClick={() => nav(`/compasso/experiencia/${e.id}`)}
          >
            <ExperienciaFoto midias={e.midias} nome={e.nome} tipo={e.tipo} />
            <div className="crescer">
              <div className="row-entre">
                <div className="nome">{e.nome}</div>
                <StatusExperienciaBadge status={e.status} />
              </div>
              <div className="meta">{STATUS_EXPERIENCIA_LABEL[e.status]}</div>
              <IndicadorEngajamento experienciaId={e.id} momentos={momentos} />
            </div>
          </button>
        ))}
        </div>
      )}
    </main>
  );
}
